import CardWithTitle from 'components/CardWithTitle';
import React from 'react';
import ProductImg from 'assets/product-img.png';
import { Col, Label, Row } from 'reactstrap';

const InfoCard = (props) => {
  const { offerId, gradeName, category, rate, createDate, validity } = props;
  return (
    <CardWithTitle title="Offer">
      <div className="product-info-row mb-2 d-flex align-items-start align-items-lg-center position-relative">
        <img src={ProductImg} alt="product-img" />
        <Row className="mb-2 w-100 align-items-center">
          <Col sm={4}>
            <Label className="f-12 text-uppercase fw-medium text-gray  d-block mb-0">
              Offer ID
            </Label>
            <p className="f-12 font-manrope fw-medium mb-2">{offerId}</p>
          </Col>
          <Col sm={4}>
            <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
              GRADE NAME
            </Label>
            <p className="f-12 font-manrope fw-medium mb-2 text-capitalize">
              {gradeName}
            </p>
          </Col>
          <Col sm={4}>
            <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
              CATEGORY
            </Label>
            <p className="f-12 font-manrope fw-medium mb-2">{category}</p>
          </Col>
          <Col sm={4}>
            <Label className="f-12 text-uppercase fw-medium text-gray  d-block mb-0">
              RATE
            </Label>
            <p className="f-12 font-manrope fw-medium mb-2">{rate}</p>
          </Col>
          <Col sm={4}>
            <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
              CREATED ON
            </Label>
            <p className="f-12 font-manrope fw-medium mb-2 text-capitalize">
              {createDate}
            </p>
          </Col>
          <Col sm={4}>
            <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
              VALIDITY
            </Label>
            <p className="f-12 font-manrope fw-medium mb-2">{validity}</p>
          </Col>
        </Row>
      </div>
    </CardWithTitle>
  );
};

export default InfoCard;
